const pathAPI = '/user-service/api/users';

export const apiAuth = {
  getTokenByPassword: `${pathAPI}/login`,
  getUserInfo: `/user-service/api/partner/app/getInfo`,
  sendPostRegister: `${pathAPI}/register`,
  changePassword: `${pathAPI}/changePass`,
  msisdnIsExist: `${pathAPI}/msisdnIsExist`,
};
